import { render, staticRenderFns } from "./matching-list.vue?vue&type=template&id=7d9ccc88"
import script from "./matching-list.vue?vue&type=script&lang=js"
export * from "./matching-list.vue?vue&type=script&lang=js"
import style0 from "./matching-list.vue?vue&type=style&index=0&id=7d9ccc88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports